import * as React from 'react'

const SvgTranslateIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.25 10.875H14v1.25h-3.75v-1.25zm0-2.5h7.5v1.25h-7.5v-1.25zm0-2.5h7.5v1.25h-7.5v-1.25zm-2.5 6.25v-1.25H4.625v-1.25h-1.25v1.25H.25v1.25h5.134A5.37 5.37 0 014 14.611a5.793 5.793 0 01-.904-1.236H1.708a6.784 6.784 0 001.34 2.06A9.163 9.163 0 01.876 16.58l.439 1.171c.961-.35 1.865-.842 2.681-1.46.82.618 1.727 1.11 2.692 1.46l.438-1.17a9.165 9.165 0 01-2.173-1.142 6.446 6.446 0 001.705-3.313H7.75zm-1.77-5h1.353L4.47.25H3.114L.25 7.125h1.354l.521-1.25h3.333l.521 1.25zm-3.334-2.5l1.145-2.75 1.147 2.75H2.646z"
      fill="#163250"
    />
  </svg>
)

export default SvgTranslateIcon
